// extracted by mini-css-extract-plugin
module.exports = {"container":"frequentQuestions_container__rwvYt","left":"frequentQuestions_left__irMij","h":"frequentQuestions_h__sj2Wx","rigth":"frequentQuestions_rigth__nLVK3"};